export const EVENT_AUTH_LOGGED_IN = 'EVENT_AUTH_LOGGED_IN'
export const EVENT_AUTH_LOGOUT = 'EVENT_AUTH_LOGOUT'


export const CompanyAttorneyAdded = 'CompanyAttorneyAdded';
export const CompanyAttorneyEdited = 'CompanyAttorneyEdited';
export const CompanyAttorneyDeleted = 'CompanyAttorneyDeleted';

export const SignSuccess = 'SignSuccess'
export const SignGetHashCodeFailed = 'SignGetHashCodeFailed'
export const SignGotInvalidHashCode = 'SignGotInvalidHashCode'
export const SignEimzoFailed = 'SignEimzoFailed'
export const SignBalanceLowFailed = 'SignBalanceLowFailed'
export const SignCreditLimitIsLowFailed = 'SignCreditLimitIsLowFailed'
export const SignSignatureValidationFailed = 'SignSignatureValidationFailed'
export const SignRoamingSignatureValidationFailed = 'SignRoamingSignatureValidationFailed'
export const SignRoamingServiceProcessingFailed = 'SignRoamingServiceProcessingFailed'
export const SignUnknownErrorFailed = 'SignUnknownErrorFailed'

export const TriggerOpenContacts = 'TriggerOpenContacts'